export const createGetContentInterviewsRequest = (
  page = 1,
  per_page = 20,
  status,
  filters = {}
) => {
  const params = { page, per_page };
  if (status) params.status = status;
  if (filters.pillar) params.pillar = filters.pillar;
  if (filters.video_required === true || filters.video_required === "true") {
    params.video_required = true;
  } else if (
    filters.video_required === false ||
    filters.video_required === "false"
  ) {
    params.video_required = false;
  }
  if (
    Array.isArray(filters.workspace_ids) &&
    filters.workspace_ids.length > 0
  ) {
    params.workspace_ids = filters.workspace_ids;
  }
  if (typeof filters.topic === "string" && filters.topic.trim().length > 0) {
    params.topic = filters.topic.trim();
  }
  return {
    url: "/orgs/content_interviews",
    method: "GET",
    params,
  };
};

export const createGetContentInterviewRequest = (id) => {
  return {
    url: "/orgs/content_interviews/" + id,
    method: "GET",
  };
};

export const createContentInterviewRequest = (data) => {
  return {
    url: "/orgs/content_interviews",
    method: "POST",
    data,
  };
};

export const createUpdateContentInterviewRequest = (id, data) => {
  return {
    url: "/orgs/content_interviews/" + id,
    method: "PUT",
    data,
  };
};

export const createGenerateInterviewQuestionsRequest = (id) => {
  return {
    url: "/orgs/content_interviews/" + id + "/generate_questions",
    method: "POST",
  };
};

export const createGetQuestionsStatusRequest = (id) => {
  return {
    url: "/orgs/content_interviews/" + id + "/questions_status",
    method: "GET",
  };
};

export const createUpdateWorkspaceQuestionsRequest = (interviewId, workspaceId, questions) => {
  return {
    url: "/orgs/content_interviews/" + interviewId + "/workspaces/" + workspaceId + "/questions",
    method: "PUT",
    data: { questions },
  };
};

export const createRegenerateQuestionRequest = (interviewId, workspaceId, questionId) => {
  return {
    url: "/orgs/content_interviews/" + interviewId + "/workspaces/" + workspaceId + "/questions/" + questionId + "/regenerate",
    method: "POST",
  };
};

export const createAttachWorkspacesToInterviewRequest = (id, workspaceIds) => ({
  url: `/orgs/content_interviews/${id}/workspaces`,
  method: "POST",
  data: { workspace_ids: workspaceIds },
});

export const createPushInterviewRequest = (id, data) => {
  const request = {
    url: `/orgs/content_interviews/${id}/push`,
    method: "POST",
  };
  if (data !== undefined) {
    request.data = data;
  }
  return request;
};

export const createGeneratePublicLinkRequest = (interviewId, workspaceId) => ({
  url: `/orgs/content_interviews/${interviewId}/workspaces/${workspaceId}/generate_public_link`,
  method: "POST",
});

export const createDeleteContentInterviewRequest = (id) => {
  return {
    url: "/orgs/content_interviews/" + id,
    method: "DELETE",
  };
};

export const createRemindInterviewRequest = (id, workspaceIds) => {
  const data =
    Array.isArray(workspaceIds) && workspaceIds.length > 0
      ? { workspace_ids: workspaceIds }
      : undefined;
  return {
    url: "/orgs/content_interviews/" + id + "/remind",
    method: "POST",
    data,
  };
};

export const createGeneratePostsFromWorkspaceRequest = (interviewId, workspaceId, data) => {
  return {
    url: "/orgs/content_interviews/" + interviewId + "/workspaces/" + workspaceId + "/generate_posts",
    method: "POST",
    data,
  };
};
